"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isSuccessStatus = void 0;
const isSuccessStatus = (status) => status >= 200 && status < 300;
exports.isSuccessStatus = isSuccessStatus;
